import { Pipe, PipeTransform } from '@angular/core';
import { TranslationService } from './translation.service';

@Pipe({
    name: 'translate',
    pure: false
})

export class TranslatePipe implements PipeTransform {
  	cachedData = {};

    constructor(private _trans: TranslationService) { 
        this._trans.getDataFile();

    }

    transform(value: string): any {        
        if (!value) return;
        return this._trans.instant(value);

    }

    // transform(value: string, args: any[]): any {
        
    //     if (!value) return;

    //     var date = new Date();
    //     var timeStamp = date.getTime();
    //     var translation = localStorage.getItem('translationData');
        
    //     if( translation ) {
    //         // console.log("Loaded From Cache");
    //         var translationData  = JSON.parse(translation);
    //         var timeDiff = timeStamp - translationData.timestamp;
            
    //         this._trans._lang = translationData.data;
    //         return this._trans.instant(value);
    //     }

    //     if( ! translation ) {

    //         this._trans.LoadDataFile().subscribe(
    //             data => this._trans.translationObj = data.values,
    //             () => {
    //                 this._trans.createDict();
    //                 return this._trans.instant(value);
    //             }
    //         );

    //     }

    // }


}